<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="主题名称">
                <el-input v-model="queryForm.subjectName"></el-input>
            </el-form-item>
            <el-form-item label="主题颜色">
                <el-input v-model="queryForm.subjectColor"></el-input>
            </el-form-item>
            <el-form-item label="主题截图">
                <el-input v-model="queryForm.screenShot"></el-input>
            </el-form-item>
            <el-form-item label="图片路径">
                <el-input v-model="queryForm.imagePath"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="queryForm.remarks"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMppAppSubjectList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addMppAppSubject"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editMppAppSubject(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMppAppSubject(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
            class="icon-box"
            @click="refreshMppAppSubjectList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="mppAppSubjectList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="subjectName"
                    label="主题名称"
                    min-width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="subjectColor"
                    label="主题颜色"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <div style="position: relative;display: flex;justify-content: center; align-items: center;">
                            <div :style="'height: 23px;width: 23px;border-radius: 4px;background-color: ' + scope.row.subjectColor"></div><span style="margin-left: 10px;width: 55px">{{scope.row.subjectColor}}</span>
                        </div>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="colorImportant"-->
<!--                    label="主要颜色"-->
<!--                    min-width="180"-->
<!--                ></el-table-column>-->
                <!-- <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="screenShot"
                    label="主题截图"
                    min-width="180"
                ></el-table-column> -->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="imagePath"
                    label="图片路径"
                    min-width="180"
                ></el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="remarks"-->
<!--                    label="备注"-->
<!--                    min-width="180"-->
<!--                ></el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    min-width="180"
                ></el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkMppAppSubject(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMppAppSubject(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteMppAppSubject(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="mppAppSubjectStates[mppAppSubjectState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="mppAppSubject"
                        ref="mppAppSubjectForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="主题名称"
                            prop="subjectName"
                        >
                            <el-input
                                style="width: 216px;"
                                size="small"
                                v-model="mppAppSubject.subjectName"
                                :disabled="mppAppSubjectState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="主题颜色"
                            prop="subjectColor"
                        >
                            <!-- <el-input
                              style="width: 216px;"
                              size="small"
                              v-model="mppAppSubject.subjectColor"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.subjectColor"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.subjectColor" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="主要颜色"
                            prop="colorMain"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorMain"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorMain"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorMain" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="辅助颜色"
                            prop="colorAssist"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorAssist"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorAssist"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorAssist" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="文本反色"
                            prop="colorReverse"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorReverse"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorReverse"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorReverse" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="背景颜色"
                            prop="colorBg"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorBg"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorBg"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorBg" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="前景颜色"
                            prop="colorFg"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorBg"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorFg"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorFg" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="价格颜色"
                            prop="colorPrice"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorPrice"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorPrice"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorPrice" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="重要颜色"
                            prop="colorImportant"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorImportant"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'"
                                          v-model="mppAppSubject.colorImportant" size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorImportant" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="标题颜色"
                            prop="colorTitle"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorTitle"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorTitle"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorTitle" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="文本颜色"
                            prop="colorText"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorText"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorText"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorText" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="提示颜色"
                            prop="colorTips"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorTips"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorTips"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorTips" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="错误颜色"
                            prop="colorError"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorError"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorError"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorError" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="警告颜色"
                            prop="colorWarning"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorWarning"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorWarning"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorWarning" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="成功颜色"
                            prop="colorSuccess"
                        >
                            <!-- <el-input
                              size="small"
                              v-model="mppAppSubject.colorSuccess"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <div style="display: flex;align-items: center;width: 216px;">
                                <el-input :disabled="mppAppSubjectState == 'check'" v-model="mppAppSubject.colorSuccess"
                                          size="small"></el-input>
                                <el-color-picker :disabled="mppAppSubjectState == 'check'"
                                                 v-model="mppAppSubject.colorSuccess" size="small"
                                                 style="margin-left: 2px;"></el-color-picker>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="图片路径"
                            prop="imagePath"
                        >
                            <el-input
                                style="width: 216px;"
                                size="small"
                                v-model="mppAppSubject.imagePath"
                                :disabled="mppAppSubjectState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="备注"
                            prop="remarks"
                        >
                            <el-input
                                size="small"
                                v-model="mppAppSubject.remarks"
                                style="width: 216px;"
                                :disabled="mppAppSubjectState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="是否激活"
                            prop="isActive"
                        >
                            <el-select
                                style="width: 216px;"
                                v-model="mppAppSubject.isActive"
                                size="small"
                                placeholder="请选择"
                                :disabled="mppAppSubjectState == 'check'"
                            >
                                <el-option
                                    label="是"
                                    :value="1"
                                ></el-option>
                                <el-option
                                    label="否"
                                    :value="0"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="主题截图"
                            prop="screenShot"
                        >
                            <!-- <el-input
                              size="small"
                              style="width: 216px;"
                              v-model="mppAppSubject.screenShot"
                              :disabled="mppAppSubjectState == 'check'"
                            ></el-input> -->
                            <el-upload
                                :disabled="mppAppSubjectState == 'check'"
                                style="width: 216px"
                                class="avatar-uploader"
                                action=""
                                :before-upload="beforeUpload"
                                multiple
                                :show-file-list="true"
                                :http-request="uploadAvatar">
                                <div style="width: 216px;height: 216px;overflow: auto;" v-if="mppAppSubject.screenShot.length > 0">
                                    <el-image
                                        style="width: 200px;height: 200px;"
                                        :src="item"
                                        v-for="(item,index) in mppAppSubject.screenShot" lazy />
                                </div>
                                <!-- <img v-if="mppAppSubject.screenShot" :src="mppAppSubject.screenShot" class="avatar"
                                     size="small" /> -->
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div slot="tip" class="el-upload__tip">请点击多张图片上传</div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="mppAppSubjectState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppAppSubjectList();
                this.getMppAppSubjectList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppAppSubjectList();
                this.getMppAppSubjectList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                subjectName: '', //主题名称
                subjectColor: '', //主题颜色
                screenShot: '', //主题截图
                imagePath: '', //图片路径
                remarks: '', //备注
                createTime: '', //创建时间
                isActive: '',
                colorMain: '',
                colorAssist: '',
                colorPrice: '',
                colorImportant: '',
                colorTitle: '',
                colorText: '',
                colorReverse: '',
                colorTips: '',
                colorError: '',
                colorWarning: '',
                colorSuccess: '',
                colorBg: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppAppSubjectState: 'add',
            mppAppSubjectStates: {
                add: '新建主题',
                check: '查看主题',
                edit: '修改主题'
            },

            multipleSelection: [],
            mppAppSubjectList: [],
            mppAppSubject: {
                subjectName: '', //主题名称
                subjectColor: '', //主题颜色
                screenShot: [], //主题截图
                imagePath: '', //图片路径
                remarks: '', //备注
                createTime: '', //创建时间
                isActive: '',
                colorMain: ''
            },
            btnLoading: false,

            rules: {
                subjectName: [{ required: true, message: '主题名称不能为空', trigger: 'blur' }],
                subjectColor: [{ required: true, message: '主题颜色不能为空', trigger: 'blur' }],
                screenShot: [{ required: true, message: '主题截图不能为空', trigger: 'blur' }],
                imagePath: [{ required: true, message: '图片路径不能为空', trigger: 'blur' }],
                remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                colorMain: [{ required: true, message: '主题主色不能为空', trigger: 'blur' }],
                colorAssist: [{ required: true, message: '主题辅助色不能为空', trigger: 'blur' }],
                colorPrice: [{ required: true, message: '主题价格色不能为空', trigger: 'blur' }],
                colorImportant: [{ required: true, message: '主题重要色不能为空', trigger: 'blur' }],
                colorTitle: [{ required: true, message: '主题标题色不能为空', trigger: 'blur' }],
                colorText: [{ required: true, message: '主题文字色不能为空', trigger: 'blur' }],
                colorReverse: [{ required: true, message: '主题文字反色不能为空', trigger: 'blur' }],
                colorTips: [{ required: true, message: '主题提示色不能为空', trigger: 'blur' }],
                colorError: [{ required: true, message: '主题错误色不能为空', trigger: 'blur' }],
                colorWarning: [{ required: true, message: '主题警告色不能为空', trigger: 'blur' }],
                colorSuccess: [{ required: true, message: '主题成功色不能为空', trigger: 'blur' }],
                colorBg: [{ required: true, message: '主题背景色不能为空', trigger: 'blur' }],
                colorFg: [{ required: true, message: '主题前景色不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMppAppSubjectList();
    },
    methods: {
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppAppSubject.screenShot.push(res.url);
                }
            });
        },
        beforeUpload(){
            this.mppAppSubject.screenShot = [];
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMppAppSubjectList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppAppSubjectList = [];
        },
        resetDialog() {
            this.mppAppSubjectState = 'add';
            this.showDialog = false;
            this.queryForm = {
                subjectName: '', //主题名称
                subjectColor: '', //主题颜色
                screenShot: '', //主题截图
                imagePath: '', //图片路径
                remarks: '', //备注
                createTime: '', //创建时间
                isActive: '',
                colorMain: '',
                colorAssist: '',
                colorPrice: '',
                colorImportant: '',
                colorTitle: '',
                colorText: '',
                colorReverse: '',
                colorTips: '',
                colorError: '',
                colorWarning: '',
                colorSuccess: '',
                colorBg: ''
            };
            this.getMppAppSubjectList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppAppSubject = {
                subjectName: '', //主题名称
                subjectColor: '', //主题颜色
                screenShot: [], //主题截图
                imagePath: '', //图片路径
                remarks: '', //备注
                createTime: '', //创建时间
                isActive: '',
                colorMain: ''

            };
        },
        submitForm() {
            if (this.mppAppSubjectState == 'add') {
                this.mppAppSubject.screenShot = this.mppAppSubject.screenShot.join('|');
                this.$refs.mppAppSubjectForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/appsubject/add`, { ...this.mppAppSubject }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppSubjectList();
                                this.closeDialog();
                                this.resetDialog()
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.mppAppSubjectState == 'edit') {
                this.mppAppSubject.screenShot = this.mppAppSubject.screenShot.join('|');
                console.log()
                this.$refs.mppAppSubjectForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/appsubject/edit`, { ...this.mppAppSubject }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppSubjectList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMppAppSubject() {
            this.showDialog = true;
            this.mppAppSubjectState = 'add';
        },
        checkMppAppSubject(mppAppSubjectId) {
            console.log(mppAppSubjectId);
            this.currentMppAppSubjectId = mppAppSubjectId;

            this.getMppAppSubjectById();
            this.showDialog = true;
            this.mppAppSubjectState = 'check';
        },
        editMppAppSubject(mppAppSubjectId) {
            console.log('mppAppSubject', mppAppSubjectId);
            if (mppAppSubjectId) {
                this.currentMppAppSubjectId = mppAppSubjectId;
                this.getMppAppSubjectById();
            } else {
                this.mppAppSubject = { ...this.mppAppSubject, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppAppSubjectState = 'edit';
        },
        deleteMppAppSubject(mppAppSubjectId) {
            let ids = '';
            if (mppAppSubjectId) {
                ids = mppAppSubjectId;
            } else {
                ids = this.multipleSelection.map((mppAppSubject) => mppAppSubject.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/appsubject/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppAppSubjectList();
                            this.getMppAppSubjectList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppAppSubjectList() {
            this.resetMppAppSubjectList();
            this.getMppAppSubjectList();
        },
        getMppAppSubjectList(query = {}) {
            this.loading = true;
            get(`/mpp/appsubject/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppAppSubjectList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMppAppSubjectById() {
            get(`/mpp/appsubject/get`, { id: this.currentMppAppSubjectId }).then((res) => {
                if (res.success) {
                    res.mppAppSubject.screenShot = res.mppAppSubject.screenShot.split('|');
                    this.mppAppSubject = { ...this.mppAppSubject, ...res.mppAppSubject };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppAppSubjectList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/appsubject/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/appsubject/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/appsubject/importData`, formData);
            this.refreshMppAppSubjectList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppAppSubjectList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppAppSubjectList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 216px;
    height: 216px;
    line-height: 216px;
    text-align: center;
}

.avatar {
    width: 216px;
    height: 216px;
    display: block;
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 216px;
    height: 216px;
}
</style>